import $ from "jquery";
// old imports

// needed to make kits UI work
require("../js/_kits").default;

let Dispatcher = require("../dispatcher/dispatcher").default,
    get_parameter_by_name = require("../helpers/get_parameter_by_name").default,
    HeroPreview = require("./hero-preview"),
    HeroMeta = require("./hero-meta"),
    Metrics = require("../helpers/metrics").default,
    React = require("react");

// new imports
import * as actions from "../../actions/actions";
import { connect } from "react-redux";
import ColorSelection from "../../components/color-selection";
import ColorPicker from "../../components/nounproject-color-picker";
import { SuperUserActions } from "../../components/fort-super-user-actions";

class Hero extends React.Component {
    componentDidMount() {
        this.scrollHeroToTop();

        if (this.activeProps.icon !== undefined) {
            if (this.state.purchase === "true") {
                Dispatcher.dispatch({
                    actionType: "requestDownload",
                    icon: this.activeProps.icon,
                    imgType: "svg",
                    img_color: "000000"
                });
            }

            return new Metrics().icon_hero(this.activeProps.icon.id);
        }

        return null;
    }

    componentWillUpdate(nextProps, nextState) {
        this.activeProps = nextProps;

        if (this.props.args) {
            this.activeProps = this.props.args;
        }

        if (this.props.icon) {
            if (this.props.icon.id !== nextProps.icon.id) {
                // Switching icons in same row
                this.scrollHeroToTop();
            }
        }
    }

    componentWillUnmount() {
        $("#page-wrapper").removeClass("hero-active");
        return null;
    }

    constructor(props) {
        super(props);

        this.activeProps = this.props;

        if (this.props.args) {
            this.activeProps = this.props.args;
            this.props.fetchIcon(this.activeProps.icon.id);
        }

        this.props.getIconMetaData();

        this.fetchingSvg = undefined;
        this.state = {
            fetchingSvg: undefined,
            transparentBG: false,
            transitionColor: "#FF0000",
            purchase: get_parameter_by_name("purchase"),
            downloadFileType: get_parameter_by_name("file_type")
        };
    }

    handleDownload(imgType) {
        let img_color;

        if (!this.props.selectedColor) {
            img_color = "000000";
        } else {
            if (this.props.selectedColor.hex === "Black") {
                img_color = "000000";
            } else if (this.props.selectedColor.hex === "White") {
                img_color = "ffffff";
            } else {
                img_color = this.props.selectedColor.hex.split("#")[1];
            }
        }
        Dispatcher.dispatch({
            actionType: "requestDownload",
            icon: this.activeProps.icon,
            imgType,
            img_color: img_color
        });
        if (this.activeProps.showNotification !== undefined) {
            return this.activeProps.showNotification();
        }
    }

    showShareModal(e) {
        if (e !== void 0) {
            e.preventDefault();
        }

        Dispatcher.dispatch({
            actionType: "showShareModal",
            show: true,
            icon: this.activeProps.icon
        });
    }

    scrollHeroToTop() {
        let heroOffsetTop = 81,
            $heroScroll = $(".hero-container");

        if ($(window).width() > 768) {
            if ($heroScroll.length === 0) {
                return;
            }
            if (this.activeProps.animateScroll) {
                $("html,body").animate(
                    {
                        scrollTop: $heroScroll.offset().top - heroOffsetTop
                    },
                    500
                );
            } else {
                $("html,body").scrollTop(
                    $heroScroll.offset().top - heroOffsetTop
                );
            }
        } else {
            $("#page-wrapper").addClass("hero-active");
        }
    }

    render() {
        let iconProps, superUserActions;

        if (
            this.props.currentUser !== undefined &&
            this.props.currentUser.is_superuser
        ) {
            superUserActions = (
                <SuperUserActions
                    superUser={this.props.currentUser.is_superuser}
                    iconId={this.activeProps.icon.id}
                    uploaderId={this.activeProps.icon.uploader_id}
                />
            );
        }

        if (this.props.args) {
            iconProps = this.props.args.icon;
        }

        if (this.props.activeIcon || iconProps) {
            let close_btn,
                heroPreview,
                heroEditing,
                heroMeta,
                iconCollections,
                nonEditableCollections = ["615", "851", "911"],
                isEditable = true;

            if (this.activeProps.onHeroClose) {
                close_btn = (
                    <a
                        className="esc-page ui_close"
                        title="Close this menu"
                        href="#"
                        onClick={this.activeProps.onHeroClose.bind(this)}
                    />
                );
            }
            if (this.activeProps.icon !== undefined) {
                iconCollections = this.activeProps.icon.collections;
                if (iconCollections) {
                    if (iconCollections.length > 0) {
                        if (
                            nonEditableCollections.includes(
                                iconCollections[0].id
                            )
                        ) {
                            isEditable = false;
                        }
                    }
                } else {
                    if (
                        nonEditableCollections.includes(
                            this.activeProps.collection.id
                        )
                    ) {
                        isEditable = false;
                    }
                }

                heroPreview = (
                    <HeroPreview
                        icon={this.activeProps.icon}
                        transparentBG={this.state.transparentBG}
                        selectedColor={this.props.selectedColor}
                        transitionColor={this.state.transitionColor}
                        unlockColor={this.unlockColor.bind(this)}
                        store={this.props.store}
                        isEditable={isEditable}
                    />
                );

                heroMeta = (
                    <HeroMeta
                        collection={this.activeProps.collection}
                        icon={this.activeProps.icon}
                        showShareModal={this.showShareModal.bind(this)}
                        store={this.props.store}
                        download={this.handleDownload.bind(this)}
                    />
                );
            }

            if (isEditable) {
                heroEditing = (
                    <ColorSelection
                        store={this.props.store}
                        icon={this.activeProps.icon}
                    />
                );
            }

            return (
                <section className="hero-container">
                    <style>{`

                            @media only screen and (max-width: 350px) {
                                .icon-editing{
                                    flex-direction: column;
                                }
                            }
                            @media only screen and (max-width: 250px) {
                                .the-icon-container{
                                    min-height: 430px;
                                }
                            }
                            @media only screen and (max-width: 200px) {
                                .the-icon-container{
                                    min-height: 200px;
                                }
                            }
                            @media only screen and (max-width: 150px) {
                                .the-icon-container{
                                    min-height: 150px;
                                }
                            }

                        `}</style>
                    <div className="hero-page-width-container margin-b-m">
                        {superUserActions}
                        <div className="view-container">
                            {close_btn}
                            {heroPreview}
                            {heroEditing}
                        </div>
                        {heroMeta}
                    </div>
                </section>
            );
        } else {
            return null;
        }
    }

    unlockColor(e) {
        e.preventDefault();

        if (
            this.props.currentUser !== undefined &&
            this.props.currentUser.is_anonymous === false
        ) {
            window.location = `/${
                this.props.currentUser.username
            }/settings/upgrade/?term=${this.activeProps.icon.term}&icon_id=${
                this.activeProps.icon.id
            }`;
        } else {
            window.location = `/accounts/signup/color/?term=${
                this.activeProps.icon.term
            }&icon_id=${this.activeProps.icon.id}`;
        }
    }
}

function mapStateToProps(state, ownProps) {
    let activeIcon,
        currentUser,
        viewMore = {};

    let { apiResponse, icons } = state;
    let { selectedColor } = icons;

    activeIcon = ownProps.icon;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    if (!activeIcon) {
        // hero is mounted directly in dom and needs to get
        if (ownProps.args) {
            activeIcon = ownProps.args.icon;
        }
    }

    if (state.icons.viewMore) {
        viewMore.icons = [];
        state.icons.viewMore.keys.forEach(viewMoreKey => {
            viewMore.icons.push(state.icons.viewMore[viewMoreKey]);
        });
        viewMore.collection = state.icons.viewMore.collection;
        viewMore.totalRelatedCount = state.icons.total_related_count;
    }

    return {
        apiResponse,
        activeIcon,
        currentUser,
        viewMore,
        selectedColor
    };
}

module.exports = connect(mapStateToProps, {
    getIconMetaData: actions.getIconMetaData,
    getCurrentUser: actions.getCurrentUser,
    fetchIcon: actions.fetchIcon
})(Hero);
